import qs from 'qs'
import { Base64 } from 'js-base64'
import { isIOS, isAlipay } from './util'

/**
 * @export 活动授权
 * @param {String} url  跳转的链接
 * @returns Promise
 */
export function checkAuth(url, loading = true) {
  return this.$get({
    baseURL: this.$baseURL.cat,
    url: '/api/check_auth',
    params: {
      callback: encodeURIComponent(url)
    },
    loading
  })
}

export function checkAlipayAuth(url, loading = true) {
  return this.$get({
    baseURL: this.$baseURL.cat,
    url: '/auth/alipay/check_auth',
    params: {
      callback: encodeURIComponent(url)
    },
    loading,
    autoAuth: false
  })
}

/**
 * @export 获取优惠券车系
 * @param {Number} id   优惠券ID
 * @returns Promise
 */
export function getSerialList(coupon_id) {
  return this.$get({
    baseURL: this.$baseURL.api,
    url: '/v1/coupon/series',
    params: {
      coupon_id
    }
  })
}
export function getActivitySerialList(activity_key, coupon_id) {
  return this.$get({
    baseURL: this.$baseURL.cat,
    url: `/v1/${activity_key}/coupon/series`,
    params: {
      coupon_id
    },
    loading: false
  })
}

/**
 * @export 获取品牌列表
 * @param {String} type  类型
 * @returns Promise
 */
export function getBrandList(type = 'list') {
  return this.$get({
    baseURL: this.$baseURL.api,
    url: '/car/brands',
    params: {
      type
    }
  })
}

/**
 * @export 获取车系列表
 * @param {String} type  类型   brandId  酷车品牌id  pcBrandId汽车网品牌id
 * @returns Promise
 */
export function getFirmList(brandId, pcBrandId) {
  return this.$get({
    baseURL: this.$baseURL.api,
    url: '/car/firms',
    params: {
      type: 'list',
      brand_id: brandId,
      pc_brand_id: pcBrandId
    }
  })
}

/**
 * @export 获取城市列表
 * @returns Promise
 */
export function getCityList(loading = true) {
  return this.$get({
    baseURL: this.$baseURL.api,
    url: '/v1/comm/location/cities',
    loading
  })
}

/**
 * @export 获取指定优惠券
 * @param {Number} uid         支付宝ID
 * @param {String} coupon_ids  优惠券ID，多个优惠券以小写逗号隔开
 * @returns Promise
 */
export function getCouponList(uid, coupon_ids, loading = true) {
  return this.$get({
    baseURL: this.$baseURL.api,
    url: '/v1/coupons/get_coupons',
    params: {
      uid,
      coupon_ids
    },
    loading
  })
}

/**
 * @export 领取优惠券
 * @param {Object} obj               传入的对象
 * @param {String} obj.baseUrl       活动领券baseUrl
 * @param {String} obj.url           活动领券url
 * @param {Object} obj.data          数据
 * @param {String} obj.data.uid      用户uid（必填）
 * @param {String} obj.data.coupon   优惠券（必填）
 * @param {String} obj.data.serial   意向车系
 * @param {String} obj.data.city     城市
 * @param {String} obj.params        活动领券额外参数
 */
export function receiveCoupon(obj) {
  const { baseURL, url, data, params } = obj
  // 主库领券参数
  const pangkuData = {
    uid: data.uid,
    coupon_id: data.coupon.id,
    serial_id: data.serial.id,
    city_id: data.city.cityid,
    channel: data.channel || `ACTIVITIS_${this.$key}`
  }
  // 活动领券参数，优惠券id和标题会自动带上
  const activityData = {
    series_id: data.serial.id,
    series_name: data.serial.name,
    location_amap: data.city.longitude ? `${data.city.longitude},${data.city.latitude}` : '',
    location_province: data.city.province,
    location_city: data.city.city
  }
  const callback = `${baseURL}${url}?${qs.stringify(activityData, { encode: false })}&${qs.stringify(params, { encode: false })}`
  const jumpURL = `${this.$baseURL.merchant}/client/getcoupon?${qs.stringify(pangkuData, { encode: false })}&callback=${encodeURIComponent(callback)}`
  console.log(jumpURL)
  return new Promise((resolve, reject) => {
    if (this.$env !== 'dev') {
      ap.onResume(() => {
        ap.offResume()
        const res = JSON.parse(localStorage.getItem('couponInfo'))
        localStorage.removeItem('couponInfo')
        if (res) {
          resolve(res)
        } else {
          reject()
        }
      })
      if (isIOS) {
        ap.pushWindow(jumpURL)
      } else {
        window.location.href = jumpURL
      }
    } else {
      resolve({
        success: true
      })
    }
  })
}
export function receiveCouponNoAuth(obj) {
  const { baseURL, url, data, params } = obj
  // 主库领券参数
  const pangkuData = {
    coupon_id: data.coupon.id,
    serial_id: data.serial.id,
    city_id: data.city.cityid,
    channel: data.channel || `ACTIVITIS_${this.$key}`
  }
  // 活动领券参数，优惠券id和标题会自动带上
  const activityData = {
    series_id: data.serial.id,
    series_name: data.serial.name,
    location_amap: data.city.longitude ? `${data.city.longitude},${data.city.latitude}` : '',
    location_province: data.city.province,
    location_city: data.city.city
  }
  const callback = `${baseURL}${url}?${qs.stringify(activityData, { encode: false })}&${qs.stringify(params, { encode: false })}`
  const jumpURL = `${this.$baseURL.merchant}/AliCoupon/scanCoupon?${qs.stringify(pangkuData, { encode: false })}&callback=${encodeURIComponent(callback)}`
  console.log(jumpURL)
  if (isAlipay) {
    return new Promise(resolve => {
      if (this.$env !== 'dev') {
        ap.onResume(() => {
          ap.offResume()
          const res = JSON.parse(localStorage.getItem('couponInfo'))
          localStorage.removeItem('couponInfo')
          res && resolve(res)
        })
        if (isIOS) {
          ap.pushWindow(jumpURL)
        } else {
          window.location.href = jumpURL
        }
      } else {
        resolve({
          success: true
        })
      }
    })
  } else {
    return jumpURL
  }
}
export function receiveCouponInMiniprogram(obj) {
  const { baseURL, url, data, params } = obj
  // 主库领券参数
  const pangkuData = {
    coupon_id: data.coupon.id,
    serial_id: data.serial.id,
    city_id: data.city.cityid,
    channel: `ACTIVITIS_${this.$key}`
  }
  // 活动领券参数，优惠券id和标题会自动带上
  const activityData = {
    serial_id: data.serial.id,
    serial_name: encodeURIComponent(data.serial.name),
    location_amap: data.city.longitude ? `${data.city.longitude},${data.city.latitude}` : '',
    location_province: encodeURIComponent(data.city.province),
    location_city: encodeURIComponent(data.city.city)
  }
  const callback = `${baseURL}${url}?${qs.stringify(activityData, { encode: false })}&${qs.stringify(params, { encode: false })}`
  pangkuData.callback = callback
  const jumpURL = `${data.coupon.miniUrl}&userId=${data.uid}&extInfo=${Base64.encode(JSON.stringify(pangkuData))}`
  console.log(jumpURL)
  return new Promise(resolve => {
    if (this.$env !== 'dev') {
      resolve()
      my.postMessage({ coupon_url: jumpURL, type: 'getcoupon' })
    } else {
      resolve()
    }
  })
}

export function receivePayCoupon(obj) {
  console.log(obj)
  const { baseURL, url, data, params } = obj
  // 主库领券参数
  const pangkuData = {
    id: data.coupon.id,
    serial_id: data.serial.id,
    city_id: data.city.cityid,
    channel: `ACTIVITIS_${this.$key}`
  }
  // 活动领券参数，优惠券id和标题会自动带上
  const activityData = {
    series_id: data.serial.id,
    series_name: data.serial.name,
    location_amap: data.city.longitude ? `${data.city.longitude},${data.city.latitude}` : '',
    location_province: data.city.province,
    location_city: data.city.city
  }
  const callback = `${baseURL}${url}?${qs.stringify(activityData, { encode: false })}&${qs.stringify(params, { encode: false })}`
  const jumpURL = `${this.$baseURL.cat}/dist/coupon/paycoupon.html?${qs.stringify(pangkuData, { encode: false })}&callback=${encodeURIComponent(callback)}`
  console.log(jumpURL)
  return new Promise(resolve => {
    if (this.$env !== 'dev') {
      ap.onResume(() => {
        ap.offResume()
        const res = JSON.parse(localStorage.getItem('couponInfo'))
        localStorage.removeItem('couponInfo')
        res && resolve(res)
      })
      ap.pushWindow(jumpURL)
    } else {
      resolve({
        success: true
      })
    }
  })
}
